/**
 * Focus, site-wide (loaded on every page by layout/theme.liquid): the
 * drawers' first focus, and the pointer flag below.
 *
 * A BIRROT drawer on Horizon's <theme-drawer> (the cart drawer,
 * snippets/birrot-cart-drawer.liquid; the filter panel,
 * blocks/filters.liquid) marked `data-birrot-focus-dialog`: on open, the
 * dialog itself takes the focus, not its × (theme-drawer's choice,
 * #focusInitialElement). A dialog's first control gets the focus ring in
 * Safari however it was opened, and in Chromium for an open by script: a
 * black box round × on every add. Tab still reaches ×; the dialog's label
 * is announced.
 */
document.addEventListener('theme-drawer:open', (event) => {
  const drawer = event.target;
  if (!(drawer instanceof Element) || !drawer.hasAttribute('data-birrot-focus-dialog')) return;
  const dialog = drawer.querySelector('dialog');
  if (!dialog) return;
  dialog.tabIndex = -1;
  dialog.focus({ preventScroll: true });
});

// Focus modality, for every keyboard-only ring on the site (the product
// page's size box, the cart's size pickers and ×): a <select> matches
// :focus-visible however it was focused, so a click drew the keyboard
// ring. A pointer press marks the page (<html>, which no morph replaces)
// until focus moves by Tab (Escape or Enter on an open list keep it), and
// the stylesheets ring only `:root:not([data-birrot-pointer])`.
document.addEventListener(
  'pointerdown',
  () => {
    if (!document.documentElement.hasAttribute('data-birrot-pointer')) {
      document.documentElement.setAttribute('data-birrot-pointer', '');
    }
  },
  { capture: true, passive: true }
);

document.addEventListener(
  'keydown',
  (event) => {
    if (event.key === 'Tab') document.documentElement.removeAttribute('data-birrot-pointer');
  },
  { capture: true }
);
